import * as React from "react";
const IconMobile = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M34.9 9.5h-5.8c-1.2 0-2.3 1-2.3 2.3s1 2.3 2.3 2.3h5.8c1.2 0 2.3-1 2.3-2.3s-1.1-2.3-2.3-2.3" />
    <path d="M44.4 1.8H19.6c-3.4 0-6.3 2.8-6.3 6.3v48c0 3.4 2.8 6.3 6.3 6.3h24.9c3.4 0 6.3-2.8 6.3-6.3V8c-.1-3.4-2.9-6.2-6.4-6.2M46.2 56c0 1-.8 1.8-1.8 1.8H19.6c-1 0-1.8-.8-1.8-1.8V8c0-1 .8-1.8 1.8-1.8h24.9c1 0 1.8.8 1.8 1.8v48z" />
    <path d="M34.1 53.3c-.1-.1-.1-.2-.2-.3l-.3-.3c-.5-.5-1.3-.8-2-.6-.1 0-.3.1-.4.1s-.3.1-.4.2l-.3.3-.3.3c-.1.1-.1.3-.2.4s-.1.3-.1.4v.4c0 .6.2 1.2.7 1.6l.3.3c.1.1.3.2.4.2s.3.1.4.1h.4c.6 0 1.2-.2 1.6-.7l.3-.3c.1-.1.1-.3.2-.4s.1-.3.1-.4v-.8c-.1-.2-.2-.3-.2-.5" />
  </svg>
);
export default IconMobile;
